/**
 * Converts a number into a string with the following style:
 * "12345" => "12,345"
 * NOTE: The comma is the english version for visually separating thousands
 * Function from: "https://stackoverflow.com/a/2901298"
 */
export function numberWithCommas(number: number): string {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
